import { render, staticRenderFns } from "./DialogSetLiveTime.pug?vue&type=template&id=16cd6909&lang=pug&"
import script from "./DialogSetLiveTime.vue?vue&type=script&lang=js&"
export * from "./DialogSetLiveTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports